import { Model, Collection } from '@/models/BaseModel';

import {
    equal,
    integer,
    min,
    required,
    string,
    email,
    boolean,
    date
} from 'vue-mc/validation';

export class Promotion extends Model {
    public options() {
        return {
            identifier: 'id',
            methods: {
                sendSMS: 'POST'
            }
        };
    }

    public defaults() {
        return {
            id: null,
            name: '',
            description: '',
            startDate: '',
            endDate: '',
            discount: '',
            discountType: 0,
            isMonday: true,
            isTuesday: true,
            isWednesday: true,
            isThursday: true,
            isFriday: true,
            isSaturday: true,
            isSunday: true,
            all_products: false,
            productList: []
        };
    }

    public mutations() {
        return {
            id: (id: any) => Number(id) || null,
            name: String,
            description: String,
            startDate: String,
            endDate: String,
            discount: Number,
            discountType: Number,
            isMonday: Boolean,
            isTuesday: Boolean,
            isWednesday: Boolean,
            isThursday: Boolean,
            isFriday: Boolean,
            isSaturday: Boolean,
            isSunday: Boolean,
            all_products: Boolean,
            productList: Object
        };
    }

    public validation() {
        return {
            id: integer.and(min(1)).or(equal(null)),
            name: string.and(required),
            description: string.and(required),
            startDate: string.and(required),
            endDate: string.and(required),
        };
    }

    public routes() {
        return {
            fetch: "promotions/{id}",
            save: "promotions",
            sendSMS: "promotions/{id}/sendSMS",
            delete: "promotions/{id}"
        };
    }

    public sendSMS() {
        let method = this.getOption('methods.sendSMS');
        let route = this.getRoute('sendSMS');
        let params = this.getRouteParameters();
        let url = this.getURL(route, params);
        let data = { id: this.id };
        let headers = {}
        return this.getRequest({ method, url, data, headers }).send();
    }

}

export class PromotionCollection extends Collection {
    public model() {
        return Promotion;
    }

    public defaults() {
        return {
            orderBy: 'name',
        };
    }

    public routes() {
        return {
            fetch: "promotions",
        };
    }

    public fetchData() {
        return this.fetch();
    }
}
